import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { EvaluationAnswerCardComponent } from './evaluation-answer-card.component';

@NgModule({
	declarations: [EvaluationAnswerCardComponent],
	imports: [CommonModule, TranslateModule.forChild(), FreudTooltipModule],
	exports: [EvaluationAnswerCardComponent],
})
export class EvaluationAnswerCardModule {}
